import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { oneOfType, array, arrayOf, func, bool, object, shape, string, node } from 'prop-types';
import { ShoppingBagFast } from '@magalu/stereo-ui-icons';
import { DEFAULT_SELLER } from '../../constants';
import { Button as ButtonComponent } from '../../atoms';
import { Content, Display, Container, TitleDisplay, LogoMagaluIcon, Title, ShippingList } from './buyBox.styles';
import { SellerDelivery } from '../../organisms';
import { Price } from '../../molecules';
const TITLE_BUYBOX = 'Escolha a melhor oferta';
const BUTTON_OK = 'Comprar agora';
const BUTTON_ERROR = 'Não disponível';

const isSellerMagalu = seller => (seller == null ? void 0 : seller.id) === DEFAULT_SELLER;

const BuyBoxItem = ({
  displayMode,
  offer,
  onClick,
  showSellerInDialog,
  disableSellerClick,
  onSellerClick,
  buttons,
  modal
}) => {
  const {
    seller,
    price,
    deliveryTypes,
    error
  } = offer;
  const isMagalu = isSellerMagalu(seller);
  const {
    content: ModalContent
  } = modal;
  return /*#__PURE__*/React.createElement(Display, {
    isMagalu: isMagalu,
    displayMode: displayMode,
    "data-testid": "buybox-card-container",
    hideLinkBorder: false,
    as: "div"
  }, /*#__PURE__*/React.createElement(Content, {
    isMagalu: isMagalu,
    displayMode: displayMode,
    "data-testid": "buybox-card-content"
  }, isMagalu && displayMode === 'vertical' && /*#__PURE__*/React.createElement(LogoMagaluIcon, {
    title: "Logo magalu",
    "data-testid": "magalogo"
  }), /*#__PURE__*/React.createElement(TitleDisplay, null, /*#__PURE__*/React.createElement(Price, _extends({
    display: 'galery',
    isList: true,
    showDiscount: true
  }, price))), /*#__PURE__*/React.createElement(TitleDisplay, null, seller && /*#__PURE__*/React.createElement(SellerDelivery, {
    showDialog: showSellerInDialog,
    disableSellerClick: disableSellerClick,
    onOffersClick: onSellerClick,
    seller: seller,
    modal: Object.assign({}, modal, {
      content: modal.content && /*#__PURE__*/React.createElement(ModalContent, {
        seller: seller
      })
    })
  }))), deliveryTypes && /*#__PURE__*/React.createElement(ShippingList, {
    displayMode: displayMode,
    items: deliveryTypes
  }), /*#__PURE__*/React.createElement(ButtonComponent, {
    "data-testid": "buybox-button",
    onClick: e => onClick(e, offer),
    color: "secondary",
    startIcon: /*#__PURE__*/React.createElement(ShoppingBagFast, {
      width: 32,
      height: 32
    }),
    m: '10px 0',
    disabled: Boolean(error),
    full: true
  }, error ? buttons.buttonError : buttons.buttonOk));
};

const BuyBoxList = props => {
  const {
    data,
    disableSellerClick,
    onClick,
    showSellerInDialog,
    onSellerClick,
    textButtons,
    displayMode,
    modal
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["data", "disableSellerClick", "onClick", "showSellerInDialog", "onSellerClick", "textButtons", "displayMode", "modal"]);

  const {
    buttonError = BUTTON_ERROR,
    buttonOk = BUTTON_OK,
    title = TITLE_BUYBOX
  } = textButtons;
  return /*#__PURE__*/React.createElement(Container, rest, /*#__PURE__*/React.createElement(Title, {
    "data-testid": "buybox-title"
  }, title), data.map((el, key) => /*#__PURE__*/React.createElement(BuyBoxItem, {
    displayMode: displayMode,
    key: key,
    offer: el,
    disableSellerClick: disableSellerClick,
    onSellerClick: onSellerClick,
    onClick: onClick,
    buttons: {
      buttonError,
      buttonOk
    },
    showSellerInDialog: showSellerInDialog,
    modal: modal
  })));
};

process.env.NODE_ENV !== "production" ? BuyBoxItem.propTypes = {
  displayMode: string,
  offer: shape({
    seller: object,
    price: object,
    sku: string,
    deliveryTypes: arrayOf(shape()),
    error: oneOfType([object, string])
  }),
  showSellerInDialog: bool,
  onSellerClick: func,
  onClick: func,
  buttons: shape({
    buttonError: string,
    buttonOk: string
  }),
  disableSellerClick: bool,
  modal: shape({
    title: string,
    content: node,
    titleStyle: shape({})
  })
} : void 0;
process.env.NODE_ENV !== "production" ? BuyBoxList.propTypes = {
  displayMode: string,
  data: array,
  onClick: func,
  showSellerInDialog: bool,
  onSellerClick: func,
  textButtons: object,
  disableSellerClick: bool,
  modal: shape({
    title: string,
    content: node,
    titleStyle: shape({})
  })
} : void 0;
BuyBoxList.defaultProps = {
  displayMode: 'vertical',
  data: [],
  onClick: () => {},
  showSellerInDialog: false,
  onSellerClick: () => {},
  disableSellerClick: false,
  textButtons: {},
  modal: {}
};
export default BuyBoxList;